{
  "metadata": {
    "id": "mercury-dark",
    "name": "Mercury",
    "description": "Портировано из темы «Mercury» (dark)",
    "author": "OpenCode",
    "version": "2.0.0",
    "variant": "dark",
    "tags": [
      "dark",
      "ported"
    ],
    "source": {
      "file": "mercury.json",
      "project": "opencode",
      "url": "https://github.com/anomalyco/opencode",
      "upstreamFile": "packages/ui/src/theme/themes/mercury.json",
      "license": "MIT",
      "authoring": null
    },
    "validation": {
      "checks": 34,
      "fails": [],
      "paletteMinDeltaE": 21.4,
      "paletteTarget": 20.0,
      "paletteFloor": 18.0,
      "paletteAvgS": 0.479,
      "paletteMaxS": 0.518,
      "paletteAcid": 0,
      "surfacesMinDeltaE": 4.0,
      "surfacesTarget": 4.0,
      "surfacesRaisedTarget": 5.0,
      "surfacesAway": false,
      "syntaxMinDeltaE": 23.7,
      "syntaxVsTextMinDeltaE": 23.4,
      "chartsMinDeltaE": 34.1,
      "textSeparationDeltaE": 23.4,
      "textSeparationTarget": 10.0,
      "textSeparationFloor": 8.0,
      "textSeparationTinted": false,
      "authorialCollisions": [
        {
          "a": "keyword",
          "b": "function",
          "deltaE": 11.1
        },
        {
          "a": "keyword",
          "b": "operator",
          "deltaE": 0.0
        },
        {
          "a": "function",
          "b": "operator",
          "deltaE": 11.1
        }
      ],
      "modeLabel": "dark",
      "modeFromLuminance": "dark",
      "paletteIdenticalToPeer": false
    }
  },
  "colors": {
    "primary": {
      "base": "#8da4f5",
      "hover": "#9baff6",
      "active": "#a4b6f7",
      "foreground": "#000000",
      "muted": "#8da4f580",
      "emphasis": "#8da4f5"
    },
    "surface": {
      "background": "#171721",
      "foreground": "#dddde5",
      "muted": "#2a2a35",
      "mutedForeground": "#9d9da8",
      "elevated": "#32333d",
      "elevatedForeground": "#dddde5",
      "raised": "#4c4d57",
      "raisedForeground": "#dddde5",
      "overlay": "#171721cc",
      "subtle": "#21222c"
    },
    "interactive": {
      "border": "#4f4f59",
      "borderHover": "#4e4e58",
      "borderFocus": "#8da4f5",
      "selection": "#dddde529",
      "selectionForeground": "#dddde5",
      "focus": "#8da4f559",
      "focusRing": "#8da4f561",
      "cursor": "#dddde5",
      "hover": "#dddde51c",
      "active": "#dddde529"
    },
    "status": {
      "error": "#fc92b4",
      "errorForeground": "#000000",
      "errorBackground": "#fc92b424",
      "errorBorder": "#fc92b473",
      "warning": "#fc9b6f",
      "warningForeground": "#000000",
      "warningBackground": "#fc9b6f24",
      "warningBorder": "#fc9b6f73",
      "success": "#77c599",
      "successForeground": "#000000",
      "successBackground": "#77c59924",
      "successBorder": "#77c59973",
      "info": "#77becf",
      "infoForeground": "#000000",
      "infoBackground": "#77becf24",
      "infoBorder": "#77becf73"
    },
    "pr": {
      "open": "#77c599",
      "draft": "#a5a5af",
      "blocked": "#fc9b6f",
      "merged": "#8da4f5",
      "closed": "#fc92b4"
    },
    "syntax": {
      "base": {
        "background": "#3a3a44",
        "foreground": "#dddde5",
        "comment": "#a5a5af",
        "keyword": "#8da4f5",
        "string": "#77c599",
        "number": "#fc9b6f",
        "function": "#a7b6f8",
        "variable": "#77becf",
        "type": "#77becf",
        "operator": "#8da4f5"
      },
      "tokens": {
        "commentDoc": "#a5a5af",
        "stringEscape": "#8da4f5",
        "keywordImport": "#8da4f5",
        "storageModifier": "#8da4f5",
        "functionCall": "#a7b6f8",
        "method": "#a7b6f8",
        "variableProperty": "#a7b6f8",
        "variableOther": "#77becf",
        "variableGlobal": "#fc9b6f",
        "variableLocal": "#8da4f5",
        "parameter": "#77becf",
        "constant": "#fc9b6f",
        "class": "#77becf",
        "className": "#77becf",
        "interface": "#77becf",
        "struct": "#77becf",
        "enum": "#77becf",
        "typeParameter": "#77becf",
        "namespace": "#77becf",
        "module": "#8da4f5",
        "tag": "#8da4f5",
        "jsxTag": "#8da4f5",
        "tagAttribute": "#a7b6f8",
        "tagAttributeValue": "#77c599",
        "boolean": "#fc9b6f",
        "decorator": "#8da4f5",
        "label": "#a7b6f8",
        "regexp": "#77c599"
      }
    },
    "charts": {
      "series": [
        "#8da4f5",
        "#77becf",
        "#77c599",
        "#fc9b6f",
        "#fc92b4"
      ]
    },
    "chat": {
      "background": "#171721",
      "userMessage": "#dddde5",
      "userMessageBackground": "#32333d",
      "assistantMessage": "#dddde5",
      "assistantMessageBackground": "#2a2a35",
      "timestamp": "#a5a5af",
      "divider": "#4f4f59",
      "typing": "#a5a5af"
    },
    "loading": {
      "spinner": "#8da4f5",
      "spinnerTrack": "#2a2a35",
      "skeleton": "#2a2a35",
      "shimmer": "#44444e"
    },
    "tools": {
      "background": "#2a2a35",
      "border": "#4f4f59",
      "headerHover": "#42424c",
      "icon": "#8da4f5",
      "title": "#dddde5",
      "description": "#a5a5af",
      "edit": {
        "added": "#77c599",
        "addedBackground": "#77c59924",
        "removed": "#fc92b4",
        "removedBackground": "#fc92b424",
        "modified": "#77becf",
        "modifiedBackground": "#77becf24",
        "lineNumber": "#a5a5af"
      }
    },
    "markdown": {
      "heading1": "#dddde5",
      "heading2": "#dddde5",
      "heading3": "#dddde5",
      "heading4": "#dddde5",
      "link": "#8da4f5",
      "linkHover": "#9baff6",
      "inlineCode": "#77c599",
      "inlineCodeBackground": "#2a2a35",
      "blockquote": "#a5a5af",
      "blockquoteBorder": "#4f4f59",
      "listMarker": "#8da4f5bf",
      "bold": "#dddde5",
      "italic": "#dddde5e6",
      "strikethrough": "#a5a5af",
      "hr": "#4f4f59"
    }
  },
  "palette": {
    "version": 1,
    "colors": [
      {
        "key": "a1",
        "name": "Красный",
        "hex": "#ca7062",
        "foreground": "#000000",
        "contrast": 6.01
      },
      {
        "key": "a2",
        "name": "Лососевый",
        "hex": "#e0bda4",
        "foreground": "#000000",
        "contrast": 11.98
      },
      {
        "key": "a3",
        "name": "Янтарный",
        "hex": "#cead69",
        "foreground": "#000000",
        "contrast": 9.81
      },
      {
        "key": "a4",
        "name": "Салатовый",
        "hex": "#bdd16e",
        "foreground": "#000000",
        "contrast": 12.51
      },
      {
        "key": "a5",
        "name": "Лаймовый",
        "hex": "#ccdfac",
        "foreground": "#000000",
        "contrast": 14.72
      },
      {
        "key": "a6",
        "name": "Светло-зелёный",
        "hex": "#6ccf6c",
        "foreground": "#000000",
        "contrast": 10.78
      },
      {
        "key": "a7",
        "name": "Зелёный",
        "hex": "#72c794",
        "foreground": "#000000",
        "contrast": 10.31
      },
      {
        "key": "a8",
        "name": "Мятный",
        "hex": "#a7e3d5",
        "foreground": "#000000",
        "contrast": 14.59
      },
      {
        "key": "a9",
        "name": "Бирюзовый",
        "hex": "#6bbece",
        "foreground": "#000000",
        "contrast": 9.88
      },
      {
        "key": "a10",
        "name": "Голубой",
        "hex": "#6a97c2",
        "foreground": "#000000",
        "contrast": 6.82
      },
      {
        "key": "a11",
        "name": "Синий",
        "hex": "#5f7dc7",
        "foreground": "#000000",
        "contrast": 5.24
      },
      {
        "key": "a12",
        "name": "Васильковый",
        "hex": "#aea0dd",
        "foreground": "#000000",
        "contrast": 8.87
      },
      {
        "key": "a13",
        "name": "Фиолетовый",
        "hex": "#8c68bf",
        "foreground": "#000000",
        "contrast": 4.85
      },
      {
        "key": "a14",
        "name": "Орхидея",
        "hex": "#c665ca",
        "foreground": "#000000",
        "contrast": 6.12
      },
      {
        "key": "a15",
        "name": "Пурпурный",
        "hex": "#ca63a1",
        "foreground": "#000000",
        "contrast": 5.81
      },
      {
        "key": "a16",
        "name": "Розовый",
        "hex": "#d78a9e",
        "foreground": "#000000",
        "contrast": 8.02
      }
    ]
  }
}
